<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">Mark absent</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div class="absent_infor_section">
      <div >
        <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker0.open()" style="padding: 0px;">
            <mat-label>Choose a date</mat-label>
            <input matInput [matDatepicker]="picker0" [(ngModel)]="absentDate" readonly >
    
            <mat-datepicker-toggle matSuffix [for]="picker0"></mat-datepicker-toggle>
            <mat-datepicker #picker0 disabled="false"></mat-datepicker>
          </mat-form-field>
    </div>

  <div>
    <mat-form-field appearance="outline">
      <mat-label>Notes</mat-label>
      <textarea
      [(ngModel)]="notes"
        matInput
      ></textarea>
    </mat-form-field>
  </div>

</div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      (click)="onpost()"
      [disabled]="!absentDate"
      color="accent">
      Save
    </button>
  </mat-dialog-actions>